import Container from "react-bootstrap/Container";
import "bootstrap/dist/css/bootstrap.min.css";
import { Image } from "react-bootstrap";
import leftSteelImg1 from "../Images/steel_img_1.jpg";
import leftSteelImg2 from "../Images/steel_img_2.jpg";
import leftSteelImg3 from "../Images/ignite_img_1.jpg";
import leftSteelImg4 from "../Images/burner_img_1.jpg";

function KeepingSpiritAlive() {
    return (
        <>
            <Container className="pb-3">
                <div class="row">
                    <div class="col-12">
                        <div class="contentbox">
                        <div className="row">
                            <div className="col-12"><h1 className="cus_text60">KEEPING THE SPIRIT ALIVE</h1></div>
                            <div className="col-12 col-md-6 mb-3">
                                <div className="row">
                                    <div className="col-6">
                                        <a href="https://www.linkedin.com/posts/jindal-steel-power-ltd-_windmills-renewableenergy-steelofindia-activity-7280507588440440832-3XlS/?utm_source=share&utm_medium=member_android" target="_blank" rel="noopener noreferrer">
                                            <Image src={leftSteelImg1} alt="img" fluid />
                                        </a>
                                    </div>
                                    <div className="col-6">
                                        <a href="https://www.instagram.com/p/DEeMenwJSh2/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" target="_blank" rel="noopener noreferrer">
                                            <Image src={leftSteelImg2} alt="img" fluid />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 d-flex align-items-center">
                                <div>
                                    <h4 className="text-start subhead">
                                        <strong>Steel is India. India is Steel.</strong>
                                    </h4>
                                    <p className="cus_text30">To showcase how steel is an intrinsic part of India, we explored AI portraits of signature Indian elements in the bright and colourful Madhubani style of art.</p>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6 d-flex align-items-center">
                                <div>
                                    <h4 className="text-start subhead">
                                        <strong>The steel in our spirits moves us ahead.</strong>
                                    </h4>
                                    <p className="cus_text30">This noir style artwork represents this relentless and dynamic energy that drives us forward. It urges the viewer to keep the fire aglow and approach the new year with the strong spirit of steel.</p>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <div className="row">
                                    <div className="col-6">
                                        <a href="https://www.linkedin.com/posts/jindal-steel-power-ltd-_forgingahead-steelofindia-steel-activity-7267852070848737281-jgi8/?utm_source=share&utm_medium=member_android" target="_blank" rel="noopener noreferrer">
                                            <Image src={leftSteelImg3} alt="img" fluid />
                                        </a>
                                    </div>
                                    <div className="col-6">
                                        <a href="https://www.instagram.com/reel/DCl-DoICJJv/?igsh=MTJ2cmd1ZndiYXBqeA%3D%3D" target="_blank" rel="noopener noreferrer">
                                            <Image src={leftSteelImg4} alt="img" fluid />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </Container>
        </>
    );
}

export default KeepingSpiritAlive;
